import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API_URL = 'https://smartcommandsaas-backend.onrender.com/api';

export default function LoginRedirectPage() {
    const { token } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        const verify = async () => {
            try {
                const res = await axios.post(`${API_URL}/verify-token`, { token });
                localStorage.setItem('token', res.data.token);
                navigate('/');
            } catch (err) {
                alert("Invalid or expired login token.");
                navigate('/');
            }
        };
        verify();
    }, [token, navigate]);

    return <p>Logging in...</p>;
}
